module.exports = __webpack_public_path__ + "img/speakers-estudio.f981f2ab.png";